import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { ThemeProvider } from './context/ThemeContext.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import './styles/reset.css'
import './styles/themes.css'
import './styles/components.css'
import './styles/animations.css'
import './styles/nav-dropdown.css'
import './styles/activities.css'
import './styles/challenges.css'
import './styles/reading.css'
import './styles/cooking.css'
import './styles/writing.css'
import './styles/gardening.css'
import './styles/journaling.css'
import './styles/my-space.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
)
